import { inject, observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, DivPaper, Heading, Spacer, Text } from "src/components";
import { theme } from "src/config";
import { AuthStore, RoutingStore } from "src/stores";
import styled from "styled-components";

export interface IMultiLoginProps{
  authStore?:    AuthStore;
  routingStore?: RoutingStore;
}

const BrowserDetect = (userAgent: string) => {
  let browserName
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "Chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "Firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "Safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "Opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "Edge";
  }else{
    browserName= "No browser detection";
  }
  return browserName;
} 

export const MultiLogin = inject("authStore", "routingStore")(observer((props: IMultiLoginProps): JSX.Element => {
  const { authStore, routingStore} = props;
  const { t, i18n } = useTranslation();
  const [userAgents, setUserAgents] = React.useState<any[]>([]);

  React.useEffect(() => {
    authStore.getUserAgents().then(a => setUserAgents(a));
  }, []);

  return (
    <StyledDivPaper style={theme.paper.regular} justifyContent = "center" $center $noShadow>
      <Heading type="h3" style={{marginBottom: "1rem"}}>{t("warning")}!</Heading>
      <Text size="default" style={{marginBottom: "2rem"}}> 
        {t("multiple_login_warning")}
      </Text>
      <Text size="large" weight="bold" style={{marginBottom: "0.5rem"}}>{t("user_agents")}:</Text>
        {userAgents.map((a, idx) => (
      <ul key={idx}>
          <li>
            <Text  size="default"> 
              {BrowserDetect(a)}
              {a.browserName}
            </Text>
          </li>
      </ul>
        ))}
      <Spacer size="small"/>
      <ButtonContainer>
      <Button size="default" onClick={() => {authStore.logout();}}>{t("change_user")}</Button>
      <Button size="default" onClick={async () => { 
        await authStore.terminateUserConnections();
        routingStore.goBack();
      }}>
          {t("disconnect_other_device")}
      </Button>
      </ButtonContainer>
    </StyledDivPaper>
  );
}));

const StyledDivPaper = styled(DivPaper)`
  margin-top: 25vh;
  width:      40rem;
`

const ButtonContainer = styled.div`
  display:         flex;
  flex-direction:  row;
  justify-content: space-between;
`